import { ReactNode } from 'react'
import { NavLink } from 'libs/router'

import { cn } from 'utils/style'

type NavItemProps = {
	to: string
	icon: ReactNode
	text: string
	end?: boolean
	onClick: () => void
}

export const navItemClassName =
	'flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-left text-[13px] font-medium transition-colors [&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0 [&>svg]:stroke-2'

export const NavItem = ({ to, text, icon, end = false, onClick }: NavItemProps) => {
	return (
		<NavLink
			to={to}
			className={({ isActive }) =>
				cn(
					navItemClassName,
					isActive
						? 'bg-primary text-primary-foreground'
						: 'text-muted-foreground hover:bg-muted hover:text-foreground'
				)
			}
			onClick={onClick}
			end={end}>
			{icon}
			<span className="truncate">{text}</span>
		</NavLink>
	)
}
